import { render, staticRenderFns } from "./channel-link-footer.vue?vue&type=template&id=49b3eafe&"
import script from "./channel-link-footer.vue?vue&type=script&lang=js&"
export * from "./channel-link-footer.vue?vue&type=script&lang=js&"
import style0 from "./channel-link-footer.vue?vue&type=style&index=0&id=49b3eafe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports